export const sellingProductTypes = ["Televisions", "Mattresses"];
